import localeEN from '../../../locales/en.po.json';
import localeUK from '../../../locales/uk.po.json';

export const BASE_ROUTE_PATH = '/:lng(en|ru|uk)?';
export const DEFAULT_LANGUAGE = 'ru';
export const LANGUAGES = {
  en: 'English',
  uk: 'Українська',
  ru: 'Русский',
};
export const LOCALE_DATA = {
  en: localeEN,
  uk: localeUK,
};
